var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectedBasicPowerStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.1211 1 1 6.47493 1 13.0826C1 19.6903 12.5 33 12.5 33C12.5 33 24 19.7847 24 13.0826C24 6.38053 18.7891 1 12.5 1Z",
    fill: "#1E4247",
    stroke: "#1E4247",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedBasicPowerStation);
export default __webpack_public_path__ + "static/media/unselected-basic-power-station.360485c7a7a87b5eb8f7a646b5a96e46.svg";
export { ForwardRef as ReactComponent };